import OpenIDClient from './OpenIDClient'; // { anonymousOpenID, signUpOpenID, authenticatedOpenID }
import ApiClient from './ApiClient';

class TripsClient extends ApiClient {
    init = apiConf => {
        this.apiConf = apiConf;
    };

    /**
     * @param {string} tripId
     * @returns {Promise<Object>} The ongoing trip receipts data
     */
    getOngoingTripsReceipts = tripId =>
        this.get(OpenIDClient.authenticatedOpenID, `${this.apiConf.baseEndpoint}trips/${tripId}/paymentReceipts`);
}

export default new TripsClient();
